import { Select } from '@fourthwall/components';
import { useMembershipAccountQuery } from '@modules/Dashboard/hooks/useMembershipAccountQuery';
import React from 'react';
import { useReportType } from '../../../../hooks/useReportType';
import { useAnalyticsParams } from '../../hooks/useAnalyticsParams';
import * as S from './TiersSelect.styled';
export const TiersSelect = () => {
    const { reportType } = useReportType();
    const { queryParams: { tiersIds: [tiersIdsParam, setTiersIdsParam], }, } = useAnalyticsParams();
    const { membershipAccountQuery } = useMembershipAccountQuery();
    const getTiersOptions = () => {
        const defaultOption = [{ label: 'All', value: 'ALL' }];
        if (membershipAccountQuery.data?.tiers) {
            const tiers = membershipAccountQuery.data?.tiers.map(({ id, name }) => {
                return { label: name, value: id };
            });
            defaultOption.push(...tiers);
        }
        return defaultOption;
    };
    if (reportType !== 'memberships-members-change' && reportType !== 'memberships-total-members') {
        return null;
    }
    return (React.createElement(S.Container, null,
        React.createElement(Select, { label: "Tiers", options: getTiersOptions(), size: "medium", value: tiersIdsParam || 'ALL', onValueChange: setTiersIdsParam })));
};
